// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__IUmLS","title":"Info_title__2l6rX","selects":"Info_selects__34tHO","requiredAsterisk":"Info_requiredAsterisk__Q-7lt"};